import type { InferContractRouterOutputs } from '@orpc/contract'
import { useQuery } from '@tanstack/react-query'
import type { BaseContract } from 'pixai-contract/api/orpc'
import { orpcPublic } from './contract'

export type BannerItem =
  InferContractRouterOutputs<BaseContract>['banner']['list']['items'][number]

export function useBanners() {
  const { data, isLoading } = useQuery({
    ...orpcPublic.banner.list.queryOptions(),
  })
  return { data: data?.items, isLoading }
}
